export default "__VITE_ASSET__uo5WpR4t__"